



















import { Component, Vue } from 'vue-property-decorator';
import RoleForm from './roleForm.vue';
import { roleManage } from '../role';
import EditUsers from '../../components/editUsers.vue';
import EditPermission from '../../components/editPermission.vue';


@Component({
  components: {
    RoleForm,
    EditUsers,
    EditPermission,
  },
})
export default class RoleModal extends Vue {
  private componentName = 'role-form';
  private type = 'add';
  private visible = false;
  private title = this.$t('role.editRole').toString();
  private permissions: IPermission.IResponse.IPermissionInfo[] = [];
  private users: IUser.IResponse.IUserDetailInfo[] = [];
  public showModal(component = 'role-form', type: 'add' | 'del' = 'add') {
    this.visible = true;
    this.componentName = component;
    if (component === 'edit-users') {
      this.type = type;
      this.title = this.$t('role.updateUser').toString();
      this.users = roleManage.editData.roleInfo?.user || [];
      return;
    }
    if (component === 'edit-permissions') {
      this.type = type;
      this.title = this.$t('role.updatePermission').toString();
      this.permissions = roleManage.editData.roleInfo?.permissions || [];
      return;
    }
    if (roleManage.editData.isCreate) {
      this.title = this.$t('role.createRole').toString();
    } else {
      this.title = this.$t('role.editRole').toString();
    }
  }
  public addPermissions(permissionIds: string[]): Promise<string> {
    return roleManage.requestAddPermissions(permissionIds);
  }
  public delPermissions(permissionIds: string[]): Promise<string> {
    return roleManage.requestDelPermissions(permissionIds);
  }
  public addUsers(userIds: string[]): Promise<string> {
    return roleManage.requestAddUsers(userIds);
  }
  public delUsers(userIds: string[]): Promise<string> {
    return roleManage.requestRemoveUsers(userIds);
  }
}
